import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const CLU_JET_SCHEMA_LITERAL = {
    title: 'Schéma JET',
    description: 'JET',
    version: 0,
    keyCompression: false,
    primaryKey: 'JET_GID',
    type: 'object',
    properties: {
        JET_GID : { type : 'string', maxLength : 50 },
        JET_DATEEVENT : { type : 'string' }, 
        JET_EVT_CODE : { type : 'string' }, 
        JET_EVT_LIB : { type : 'string' }, 
        JET_EVT_DATA : { type : 'string' }, 
        USER_GID : { type : 'string' }, 
        MD_SITEGID : { type : 'string' },
        MD_SITE_LIB : { type : 'string' },
        MD_CAISSE : { type : 'string' },
        MD_CAISSE_LIB : { type : 'string' },
        MD_CAISSIERGID : { type : 'string' },
        MD_CAISSIER_LIB : { type : 'string' },
        MD_CAISSE_SESSION : { type : 'string' },
        MD_SITE_SESSION : { type : 'string' },
        MD_LOCALGID : { type : 'string' },
        ZSYNCUP_FLAG  : { type : 'number', default : 0 },
        ZSYNCUP_STATUS  : { type : 'string' },
        ZSYNCUP_ERROR_MESSAGE  : { type : 'string' },
        ZSYNCUP_DATETIME  : { type : 'string' },
        ZSYNCUP_FEEDID  : { type : 'string' }
    },
    required: [ 'JET_GID' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(CLU_JET_SCHEMA_LITERAL);
export type RxCluZJetDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const CLU_JET_SCHEMA: RxJsonSchema<RxCluZJetDocumentType> = CLU_JET_SCHEMA_LITERAL;
